import React from 'react';

import { observer } from 'mobx-react';

import classes from './ExistCustomerStep.module.scss';
import { AccountDetailsWidget } from '../../../../../customer-management';
import { CurrentPlanWidget } from './CurrentPlanWidget/CurrentPlanWidget';
import { SelectSubscription } from '../../components/SelectSubscription/SelectSubscription';
import { scanIqStore } from '../../../../stores/scanIqStore';
import { entitySignUpStore } from '../../../../../shared/stores/entity/entitySignUpStore';

const ExistCustomerStep = observer(() => {
  const { customer } = scanIqStore;
  const { entityName } = entitySignUpStore;

  const renderTitles = () => {
    if (customer?.activeSubscription) {
      return (
        <>
          <h1 className={classes.title}>
            We&apos;ve found your account!
            <br />
            You are ready to complete your scan.
          </h1>
          <p className={classes.description}>
            Please confirm your details and complete step to start your InBody scan
          </p>
        </>
      );
    }

    return (
      <>
        <h1 className={classes.title}>
          We&apos;ve found your account!
          <br />
          Complete your payment to continue.
        </h1>
        <p className={classes.description}>
          Please confirm your details, choose a payment method, and complete your purchase
          to start your InBody scan
        </p>
      </>
    );
  };

  return (
    <div>
      <div className={classes.titleRow}>{renderTitles()}</div>
      <div className={classes.contentContainer}>
        {customer && entityName && (
          <AccountDetailsWidget
            firstName={customer.firstName || ''}
            lastName={customer.lastName || ''}
            entityName={entityName}
            inbodyId={customer.inbodyId}
            dateOfBirth={customer.dateOfBirth}
            gender={customer.gender}
          />
        )}
        {customer?.activeSubscription ? (
          <CurrentPlanWidget
            subscriptionName={customer.activeSubscription.name}
            billingPeriodType={customer.activeSubscription.billingPeriodType}
          />
        ) : (
          <SelectSubscription />
        )}
      </div>
    </div>
  );
});

export { ExistCustomerStep };
